"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturesFilterBarMobile = void 0;
require("../css/features-filter-bar-mobile.scss");
var features_filter_bar_1 = require("./features-filter-bar");
var filter_manager_1 = require("./filter-manager");
var FeaturesFilterBarMobile = /** @class */ (function () {
    function FeaturesFilterBarMobile() {
    }
    FeaturesFilterBarMobile.init = function () {
        // Mobile handlers
        //events
        $(FeaturesFilterBarMobile.mobileFilterListIdSelector + " li.feature-value-item").off("click");
        $(FeaturesFilterBarMobile.mobileFilterListIdSelector + " li.feature-value-item").on("click", function (e) {
            FeaturesFilterBarMobile.clickFeatureValueEventMobile.call(this);
        });
        //action icons
        $(FeaturesFilterBarMobile.mobileFilterListIdSelector + " .feature-selected-delete").off("click");
        $(FeaturesFilterBarMobile.mobileFilterListIdSelector + " .feature-selected-delete").on("click", function (e) {
            var id = $(this).parent().data("feature-id");
            var elementsToDisable = $("#mobile-" + "feature-values-list-" + id).children(".selected");
            features_filter_bar_1.FeaturesFilterBar.clickFeatureValueEvent.call(elementsToDisable);
            return false;
        });
        $(FeaturesFilterBarMobile.mobileFilterListIdSelector + " .feature-selected-point").off("mouseenter");
        $(FeaturesFilterBarMobile.mobileFilterListIdSelector + " .feature-selected-point").on("mouseenter", function () {
            $(this).siblings().show();
            $(this).hide();
        });
        $(FeaturesFilterBarMobile.mobileFilterListIdSelector + " .feature-selected-delete").off("mouseleave");
        $(FeaturesFilterBarMobile.mobileFilterListIdSelector + " .feature-selected-delete").on("mouseleave", function () {
            $(this).siblings().show();
            $(this).hide();
        });
        FeaturesFilterBarMobile.loadClickEventForFilterButton();
    };
    FeaturesFilterBarMobile.clickFeatureValueEventMobile = function () {
        var id = $(this).data("feature-value-id");
        var featureId = $(this).data("parent-feature-id");
        $(this).toggleClass("selected");
        if ($(this).hasClass("selected")) {
            $("#mobile-feature-" + featureId).addClass("selectedWithItem");
        }
        else {
            if ($(this).siblings(".selected").length == 0) {
                $("#mobile-feature-" + featureId).removeClass("selectedWithItem");
            }
        }
        //update history with the selection
        filter_manager_1.FilterManager.setFeatures.apply(this);
    };
    FeaturesFilterBarMobile.loadClickEventForFilterButton = function () {
        //filter for mobile
        $(FeaturesFilterBarMobile.mobileFilterButtonSelector).off("click");
        $(FeaturesFilterBarMobile.mobileFilterButtonSelector).on('click', function (e) {
            if (!$("#features-filter-modal-wrapper").hasClass("active-over")) {
                $('#product-search-results').append('<div class="modal-backdrop fade in" id="bg-darken"> </div>');
                // Dark background control, plus closing when clicked outside event
                $("#bg-darken").off("click");
                $("#bg-darken").click(function (event) {
                    if ($(".mobile").css("display") == "block" && $("#features-filter-modal-wrapper").hasClass("active-over")) {
                        $("#bg-darken").remove();
                        $("#features-filter-modal-wrapper").removeClass("active-over");
                        $("#features-filter-modal-wrapper").fadeToggle();
                    }
                });
                $("#features-filter-modal-wrapper").addClass("active-over");
            }
            $("#features-filter-modal-wrapper").fadeToggle();
        });
    };
    FeaturesFilterBarMobile.mobileFilterListIdSelector = "#mobile-features-list";
    FeaturesFilterBarMobile.mobileFilterButtonSelector = "#mobile-filter";
    return FeaturesFilterBarMobile;
}());
exports.FeaturesFilterBarMobile = FeaturesFilterBarMobile;
